import React from 'react';
import ReactDOM from 'react-dom/client';
import "./components/styles/styles.css";
import "./components/assets/css/all.css";
import "./components/assets/css/meanmenu.min.css";
import "./components/assets/sass/style.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
